export const statefulPropertyKey = Symbol('StatefulProperty');

export function StatefulProperty() {
	return function(target: any, propertyKey: string | symbol) {
		const statefulProperties = Reflect.getOwnMetadata(statefulPropertyKey, target) || [];
		statefulProperties.push(propertyKey);
		Reflect.defineMetadata(statefulPropertyKey, statefulProperties, target);
	};
}
